import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext, QueryUtility, uuid } from 'core/utils';
import { ModalParams } from 'core/models';
import { FacilityOrderService, FacilityOrderTemplateService, FacilityOrderTemplateNewFlowService, FacilityOrderStatusService, FacilityOrderTemplateItemService, ItemSubcategoryService } from "application/facility-order/services";
import { LookupService } from "common/services";
import { PickTicketHeaderService } from "application/pick-ticket/services";
import { ItemCategoryService } from 'application/product/services';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { FacilityInventoryCountDetailService } from "application/facility-inventory/services";
import { ScheduleService } from 'application/schedule/services';
import { PersonService } from 'application/person/services';
import { LocalPatientService } from "application/patient/services";
import { action, observable } from 'mobx';
import _ from 'lodash';
import { InventoryRequestService } from '../../inventory-request/services';

@applicationContext
class FacilityOrderNewFlowUSIntakePreviewViewStore extends BaseViewStore {
    tabItems = [{ abrv: 'in-progress', name: 'In Progress' }, { abrv: 'discharge', name: 'Discharges' }, { abrv: 'intake-reviewed', name: 'Intake Reviewed' }];
    inactiveOptions = [{ id: "15", name: "Hospital" }, { id: "17", name: "Discharged" }, { id: "18", name: "Expired" }, { id: "0", name: "Active" }];
    questions = [{ id: "0", name: "Insurance questions" }, { id: "1", name: "Product questions" }];

    @observable accessor facilityOrder;
    @observable accessor facilityOrderStatus;
    @observable accessor disabled = false;
    @observable accessor disabledSendOrder = false;
    @observable accessor facilityOrderPatients = [];
    @observable accessor pickTicketHeaderStatus;
    @observable accessor selectedStatusAbrv;
    @observable accessor selectedQuestions = [];
    @observable accessor itemCategories = [];
    @observable accessor loadingTemplates = false;
    @observable accessor facilityOrderTemplatesGroupByPatient = [];
    @observable accessor isEmpty = false;
    @observable accessor isReviewed = undefined;
    @observable accessor isStatusBarVisible = true;
    @observable accessor isInventoryRequestSent = false;
    @observable accessor hideInventoryEmailButton = false;
    @observable accessor hasValidEmailType = false;
    @observable accessor emailType;

    constructor(rootStore) {
        super(rootStore);

        this.id = rootStore.routerStore.routerState.params.id;
        this.isAdmin = this.rootStore.userStore.user.roles.includes("Administrators");

        this.questionsStore = new BaasicDropdownStore(
            {
                multi: true,
                filterable: false,
            },
            {
                fetchFunc: () => {
                    return this.questions;
                },
            }
        );

        this.itemCategoryStore = new BaasicDropdownStore({
            multi: true, filterable: true, initFetch: false
        }, {
            fetchFunc: async (term) => {
                var itemCategoryService = new ItemCategoryService(rootStore.application.baasic.apiClient);
                const response = await itemCategoryService.find({
                    searchQuery: term,
                    rpp: 100
                });

                let filteredCategories = response.data.item.filter(i => this.facilityOrder.isEnteralWeek ? i.abrv === "enteral" : (i.abrv === "enteral" || i.abrv === "respiratory" || i.abrv === "urological" || i.abrv === "ostomy"));
                return filteredCategories;
            },
        });

        this.statusConfirmModal = new ModalParams({ onClose: null });
        this.statusConfirmModal.onConfirm = async () => { await this.setUSIntakeStarted(); this.statusConfirmModal.close(); };
        this.statusConfirmModal.onCancel = () => { this.statusConfirmModal.close() };
        this.statusConfirmModal.yesLabel = 'MODAL.START_ANYWAYS_LABEL';
        this.statusConfirmModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.statusConfirmModal.swapButtons = true;

        this.templateChangeConfirmModal = new ModalParams({ onClose: null });
        this.templateChangeConfirmModal.onConfirm = async () => { this.templateChangeConfirmModal.close(); };
        this.templateChangeConfirmModal.yesLabel = 'MODAL.ACKNOWLEDGE';
        this.templateChangeConfirmModal.doNotShowCancel = true;

        this.extraSuppliesApprovalRequiredModal = new ModalParams({ onClose: null });
        this.extraSuppliesApprovalRequiredModal.yesLabel = 'MODAL.YES';
        this.extraSuppliesApprovalRequiredModal.onCancel = () => { this.extraSuppliesApprovalRequiredModal.close() };
        this.extraSuppliesApprovalRequiredModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.extraSuppliesApprovalRequiredModal.swapButtons = true;

        this.extraSuppliesApprovalRequiredModal = new ModalParams({ onClose: null });
        this.extraSuppliesApprovalRequiredModal.yesLabel = 'MODAL.YES';
        this.extraSuppliesApprovalRequiredModal.onCancel = () => { this.extraSuppliesApprovalRequiredModal.close() };
        this.extraSuppliesApprovalRequiredModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.extraSuppliesApprovalRequiredModal.swapButtons = true;

        this.facilityOrderNewFlowUSIntakeFindAndReplaceModal = new ModalParams({});
        this.createFacilityOrderTemplateUSIntakeNewFlowModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowCalculationModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal = new ModalParams({});
        this.facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowInvoiceNoteModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakePortalNoteModal = new ModalParams({});
        this.facilityOrderTemplateDoNotSupplyModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeClinicalInformationModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowDeleteModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowDeleteQuestionModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal = new ModalParams({});
        this.facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceEditModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceNoteModal = new ModalParams({});

        this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateNewFlowService = new FacilityOrderTemplateNewFlowService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        this.itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);
        this.localPatientService = new LocalPatientService(rootStore.application.baasic.apiClient);
        this.inventoryRequestService = new InventoryRequestService(rootStore.application.baasic.apiClient);

        this.queryUtility = new QueryUtility(this.rootStore, async filter => {
            await this.fetchFacilityOrderTemplates(filter);
        }, {});

        this.fetch([
            this.initialize()
        ]);
    }

    async initialize() {
        await this.initializeFacilityOrder();
        await this.itemCategoryStore.filterAsync();
        await this.initializeFacilityOrderPatients();
        await this.initializePickTicketHeader();
        await this.initializeLookups();
        await this.initializeStatus();
    }

    @action.bound
    async initializeFacilityOrder() {
        const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        this.facilityOrder = (await facilityOrderService.get(this.id, { embed: 'Facility,Facility.FacilityAreaOfCares,Facility.Corporate_,FacilityOrderStatuses' })).data;
        this.isInventoryStepAllowed = (await facilityOrderService.isInventoryStepAllowed(this.id)).data;
        const masterPatient = (await this.localPatientService.getByPatientKey(this.facilityOrder.facility.masterPatientId, { fields: 'id' })).data;
        this.masterPatientId = masterPatient ? masterPatient.id : undefined;

        this.isInventoryRequestSent = this.facilityOrder.isInventoryRequestSent;
        this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedInventoryEmailConditions(this.id)).data;
        this.emailType = (await this.inventoryRequestService.checkIsInventoryRequestEligible(this.facilityOrder.id)).data;
        this.hasValidEmailType = this.emailType != "None";

        this.rootStore.titleStore.setTitle(`US Intake - ${this.facilityOrder.facility.name}`);
        this.facilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'us-intake');
        this.disabled = !(this.facilityOrderStatus && this.facilityOrderStatus.startedOn);
        this.disabledSendOrder = !this.isAdmin && this.facilityOrder && this.facilityOrder.sendOrder;
    }

    @action.bound
    async initializeFacilityOrderPatients() {
        this.facilityOrderPatients = (await this.facilityOrderPatientService.find({ rpp: 10000, facilityOrderId: this.facilityOrder.id, embed: "EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus,Patient" })).data.item;
    }

    @action.bound
    async initializePickTicketHeader() {
        if (!this.facilityOrder.pickTicketHeaderId) {
            const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
            this.facilityOrder.pickTicketHeaderId = (await facilityOrderService.get(this.id, { fields: 'PickTicketHeaderId' })).data.pickTicketHeaderId;
        }

        if (this.facilityOrder.pickTicketHeaderId) {
            const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
            const pickTicketHeader = (await pickTicketHeaderService.get(this.facilityOrder.pickTicketHeaderId, { embed: "pickTicketHeaderStatus" })).data;
            this.pickTicketHeaderStatus = pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.abrv;
        }
    }

    @action.bound
    async initializeLookups() {
        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        this.lookups = await lookupService.getLookups("NewFlowStatus,ItemCategory,SubCategory,ImportAction,ImportDetailStatus,ImportHeaderStatus,SpecialtyType,FacilityScheduleType");
        this.enteralItemCategoryId = this.lookups.itemCategory.find((s) => s.abrv === 'enteral').id;
        this.ostomyItemCategoryId = this.lookups.itemCategory.find((s) => s.abrv === 'ostomy').id;
        this.inProgressNewFlowStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'in-progress').id;
        this.changeNewFlowStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'change').id;
        this.newOrderNewFlowStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'new-order').id;
        this.dischargeNewFlowStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'discharge').id;
        this.noChangeNewFlowStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'no-change').id;
        this.intakeReviewedNewFlowStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'intake-reviewed').id;
        this.failedImportDetailStatusId = this.lookups.importDetailStatus.find((s) => s.abrv === 'failed').id;
        this.importedImportDetailStatusId = this.lookups.importDetailStatus.find((s) => s.abrv === 'imported').id;
        this.deleteImportActionId = this.lookups.importAction.find((s) => s.abrv === 'delete').id;
        this.updateImportActionId = this.lookups.importAction.find((s) => s.abrv === 'update').id;
        this.orderingTypeId = this.lookups.facilityScheduleType.find((s) => s.abrv === 'ordering').id;
        this.insertImportActionId = this.lookups.importAction.find((s) => s.abrv === 'insert').id;
    }

    @action.bound
    async initializeStatus() {
        let queryParams = this.rootStore.routerStore.routerState.queryParams;
        const selectedStatus = _.find(this.lookups.newFlowStatus, s => {
            return queryParams && queryParams.newFlowUSIntakeStatusIds && s.id === queryParams.newFlowUSIntakeStatusIds;
        });
        let openIntakeReviewedTab = false;
        if (this.facilityOrderStatus && this.facilityOrderStatus.completedOn) {
            openIntakeReviewedTab = !(await this.hasAnyTemplateInProgress());
        }
        const selectedStatusAbrv = selectedStatus ? selectedStatus.abrv : openIntakeReviewedTab ? 'intake-reviewed' : 'in-progress';
        this.setStatus(selectedStatusAbrv);
    }

    @action.bound
    async hasAnyTemplateInProgress(patientId) {
        let statusIds = _.map(_.filter(this.lookups.newFlowStatus, s => s.abrv === "in-progress" || s.abrv === "change" || s.abrv === "no-change" || s.abrv === "new-order"), (s => { return s.id }));
        let params = {
            newFlowUSIntakeStatusIds: statusIds.join(","),
            pageSize: 1,
            facilityOrderId: this.id,
            patientId: patientId,
            fields: 'id',
            itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : undefined,
            masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
        }
        const response = await this.facilityOrderTemplateService.find(params);
        return response.data.item && response.data.item.some(x => x.id);
    }

    @action.bound
    setStatus(statusAbrv) {
        if (this.selectedStatusAbrv == statusAbrv || this.loadingTemplates) {
            return;
        }

        this.isEmpty = false;
        this.loadingTemplates = true;
        this.facilityOrderTemplatesGroupByPatient = [];
        this.selectedStatusAbrv = statusAbrv;

        const statusIds = _.map(_.filter(this.lookups.newFlowStatus, s => this.selectedStatusAbrv === "in-progress" ? (s.abrv === "in-progress" || s.abrv === "change" || s.abrv === "no-change" || s.abrv === "new-order") : s.abrv === this.selectedStatusAbrv), (s => { return s.id }));
        this.queryUtility.filter.set('newFlowUSIntakeStatusIds', statusIds.join(","));
        this.queryUtility.fetch();
    }

    @action.bound
    async fetchFacilityOrderTemplates(filter) {
        this.loadingTemplates = true;

        let params = {
            ...filter,
            facilityOrderId: this.id,
            itemCategoryId: this.facilityOrder.isEnteralWeek ? this.enteralItemCategoryId : undefined
        }

        const itemCategoryIds = this.facilityOrder.isEnteralWeek ? [] : _.map(this.itemCategories, (i => { return i.id }));
        const showInsuranceQuestionPatients = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "0");
        const showMissingProductTemplates = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "1");

        this.facilityOrderTemplatesGroupByPatient = [];
        let filterTemplates = (await this.facilityOrderTemplateNewFlowService.find(params)).data.item.filter(t =>
            (itemCategoryIds.length == 0 || itemCategoryIds.includes(t.itemCategoryId)) &&
            (!showInsuranceQuestionPatients || this.hasPatientInsuranceQuestion(t.patientId)) &&
            (!showMissingProductTemplates || t.missingProduct)
        )
            .map(template => {
                return {
                    ...template,
                    itemsVisible: template.inactiveReasonId === 58 ? true : false
                };
            });

        let groupByPatient = _.groupBy(filterTemplates, 'patientId');
        _.each(groupByPatient, (val, key,) => {
            let facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == key);
            if (facilityOrderPatient) {
                this.facilityOrderTemplatesGroupByPatient.push({ id: `${this.selectedStatusAbrv}-${key}-${uuid()}`, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: val });
            }
        });

        if (this.selectedStatusAbrv == "discharge" || this.checkIsEmpty()) {
            await this.checkIsReviewed();
        }

        if (this.filterChange && this.facilityOrderTemplatesGroupByPatient.length === 0) {
            this.rootStore.notificationStore.warning("No templates found under selected filter");
        }

        this.filterChange = false;
        this.loadingTemplates = false;
    }

    @action.bound
    hasPatientInsuranceQuestion(patientId) {
        const facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == patientId);
        return facilityOrderPatient && facilityOrderPatient.insuranceQuestion && facilityOrderPatient.insuranceQuestion !== "";
    }

    @action.bound
    checkIsEmpty() {
        this.isEmpty = (!this.itemCategories || this.itemCategories.length == 0) && !this.selectedQuestions.some(x => x) && this.facilityOrderStatus && !this.facilityOrderStatus.completedOn && this.selectedStatusAbrv == "in-progress" && !this.facilityOrderTemplatesGroupByPatient.some(i => i.facilityOrderTemplates && i.facilityOrderTemplates.some(j => j));
        return this.isEmpty;
    }

    @action.bound
    async checkIsReviewed() {
        let params = {
            pageSize: 1,
            facilityOrderId: this.id,
            isReviewed: false,
            fields: "id"
        }

        if (this.facilityOrder.isEnteralWeek) {
            params = _.extend(params, {
                itemCategoryIds: [this.enteralItemCategoryId],
                masterPatientId: this.masterPatientId
            });
        }

        const response = await this.facilityOrderTemplateService.find(params);
        this.isReviewed = response.data.item && !response.data.item.some(i => i);
        if(this.isReviewed)
        {
            const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
            this.isInventoryRequestSent = (await facilityOrderService.hasSentEmail(this.facilityOrder.id, "InventoryRequest")).data;
            this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedInventoryEmailConditions(this.id)).data;
            this.emailType = (await this.inventoryRequestService.checkIsInventoryRequestEligible(this.facilityOrder.id)).data;
            this.hasValidEmailType = this.emailType != "None";
        }
    }

    @action.bound
    async checkIsReviewedTemplateStatusChange() {
        let params = {
            pageSize: 1,
            facilityOrderId: this.id,
            isReviewed: false,
            fields: "id"
        }

        if (this.facilityOrder.isEnteralWeek) {
            params = _.extend(params, {
                itemCategoryIds: [this.enteralItemCategoryId],
                masterPatientId: this.masterPatientId
            });
        }

        const response = await this.facilityOrderTemplateService.find(params);
        this.isReviewed = response.data.item && !response.data.item.some(i => i);
        if(this.isReviewed)
        {
            const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
            this.isInventoryRequestSent = (await facilityOrderService.hasSentEmail(this.facilityOrder.id, "InventoryRequest")).data;
            this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedInventoryEmailConditions(this.id)).data;
            this.emailType = (await this.inventoryRequestService.checkIsInventoryRequestEligible(this.facilityOrder.id)).data;
            this.hasValidEmailType = this.emailType != "None";
        }
    }

    @action.bound
    orderHistory() {
        window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.history").pattern.replace(":id", this.facilityOrder.id));
    }

    @action.bound
    async goToFacilityPreview() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", this.facilityOrder.facilityId)}`);
    }

    @action.bound
    async goToFacilityCalendar() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?facilityId=${this.facilityOrder.facilityId}&calendarTypeId=${this.orderingTypeId}`);
    }

    @action.bound
    async downloadFacilityOrder() {
        const downloadUrl = `${(await this.facilityOrderTemplateService.getDownloadNewFlowUrl({ facilityOrderId: this.facilityOrder.id }))}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadUrl, "_blank")
    }

    @action.bound
    async openInventoryRequestWindow() {
        this.emailType = (await this.inventoryRequestService.checkIsInventoryRequestEligible(this.facilityOrder.id)).data;
        this.hasValidEmailType = this.emailType != "None";
        window.open(`${this.rootStore.routerStore
            .findRoute('master.app.main.facility-order.inventory-request.new-flow-edit-email')
            .pattern.replace(":facilityOrderId", this.id)
            .replace(":inventoryRequestType", this.emailType)}?isNiko=false
        `);
    }

    @action.bound
    async openInventoryRequestWindowThroughActionsMenu() {
        this.emailType = (await this.inventoryRequestService.checkIsInventoryRequestEligible(this.facilityOrder.id)).data;
        this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedInventoryEmailConditions(this.id)).data;
        this.hasValidEmailType = this.emailType != "None";
        if(this.emailType == 'None' || this.hideInventoryEmailButton)
        {
            this.rootStore.notificationStore.error("Inventory is not necessary because we only supply covered patients in this facility.");
        }
        else
        {
            window.open(`${this.rootStore.routerStore
                .findRoute('master.app.main.facility-order.inventory-request.new-flow-edit-email')
                .pattern.replace(":facilityOrderId", this.id)
                .replace(":inventoryRequestType", this.emailType)}?isNiko=false
            `);
        }
    }

    @action.bound
    async setUSIntakeStatus(completed) {
        if (completed) {
            await this.setUSIntakeCompleted();
        }
        else {
            await this.getFacilityOrderStatus();
            const insuranceReviewStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'insurance-review');
            const initialIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'initial-intake');
            if (!(initialIntakeStatus && initialIntakeStatus.completedOn) || !(insuranceReviewStatus && insuranceReviewStatus.completedOn)) {
                this.statusConfirmModal.open({
                    message: !(initialIntakeStatus && initialIntakeStatus.completedOn) ? "This facility order has not been completed by the Initial Intake and the Insurance Review departments. Once you start US Intake, they will no longer be able to access their workflow." : "This facility order has not been completed by the Insurance Review department. Once you start US Intake, they will no longer be able to access their workflow."
                });
            }
            else {
                await this.setUSIntakeStarted();
            }
        }
    }

    @action.bound
    async setUSIntakeCompleted() {
        try {
            if (!this.facilityOrderStatus || this.facilityOrderStatus.completedOn) {
                return;
            }

            const request = { ...this.facilityOrderStatus, completedOn: new Date(), completedByUserId: this.rootStore.userStore.user.id };
            const facilityOrderStatusService = new FacilityOrderStatusService(this.rootStore.application.baasic.apiClient);
            await facilityOrderStatusService.update(request);
            await this.getFacilityOrderStatus();
            await this.openClinicalReviewPage();

            if (this.selectedStatusAbrv == "discharge" || this.checkIsEmpty()) {
                await this.checkIsReviewed();
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
    }

    @action.bound
    async getFacilityOrderStatus() {
        const facilityOrderStatusService = new FacilityOrderStatusService(this.rootStore.application.baasic.apiClient);
        var statusesResponse = await facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
        this.facilityOrder.facilityOrderStatuses = statusesResponse.data && statusesResponse.data.item;
        this.facilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'us-intake');
        this.disabled = !(this.facilityOrderStatus && this.facilityOrderStatus.startedOn);
        this.changeStatusBarVisibility();
        this.changeStatusBarVisibility();
    }

    @action.bound
    changeStatusBarVisibility() {
        this.isStatusBarVisible = !this.isStatusBarVisible;
    }

    @action.bound
    async setUSIntakeStarted() {
        try {
            if (this.facilityOrderStatus) {
                return;
            }

            const initialIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'initial-intake');
            if (initialIntakeStatus && !initialIntakeStatus.completedOn) {
                var result = await this.facilityOrderTemplateService.updateFacilityOrderTemplateIntakeStatuses({ facilityOrderId: this.facilityOrder.id });
                if (result.statusCode === 200) {
                    this.queryUtility.fetch();
                }
            }

            const status = this.lookups.importHeaderStatus.find(i => i.abrv === 'us-intake');
            const facilityOrderStatusService = new FacilityOrderStatusService(this.rootStore.application.baasic.apiClient);
            await facilityOrderStatusService.create({ facilityOrderId: this.facilityOrder.id, statusId: status.id, startedOn: new Date(), startedByUserId: this.rootStore.userStore.user.id });
            await this.getFacilityOrderStatus();

            if (this.selectedStatusAbrv == "discharge" || this.checkIsEmpty()) {
                await this.checkIsReviewed();
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
    }

    @action.bound
    async openClinicalReviewPage() {
        const personService = new PersonService(this.rootStore.application.baasic.apiClient);
        const person = (await personService.getByUser(this.rootStore.userStore.user.id)).data;

        const scheduleService = new ScheduleService(this.rootStore.application.baasic.apiClient);
        let params = {
            pageSize: 1,
            calendarTypeId: this.orderingTypeId,
            facilityOrderId: this.facilityOrder.id,
            documentRepId: person.id,
            fields: "id"
        }
        const response = await scheduleService.find(params);
        if (response.data && response.data.item && response.data.item.some(i => i)) {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.clinical-preview").pattern.replace(":id", this.facilityOrder.id));
        }
    }

    @action.bound
    filterByQuestion(selected) {
        this.selectedQuestions = selected.value;
        this.filterChange = true;
        this.queryUtility.fetch();
    }

    @action.bound
    filterByCategory(selected) {
        this.itemCategories = selected.value;
        this.filterChange = true
        this.queryUtility.fetch();
    }

    @action.bound
    goToCreatePatient() {
        this.rootStore.routerStore.goTo('master.app.main.facility-order.facility-order-new-flow.us-intake-create-patient', {
            id: this.facilityOrder.id
        });
    }

    @action.bound
    downloadInventoryReport() {
        const facilityInventoryCountDetailService = new FacilityInventoryCountDetailService(this.rootStore.application.baasic.apiClient);
        const downloadUrl = `${facilityInventoryCountDetailService.getDownloadInventoryReportUrl({ facilityOrderId: this.facilityOrder.id })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(downloadUrl, "_blank");
    }

    @action.bound
    async downloadFacilityOrderCsv() {
        const downloadUrl = `${(await this.facilityOrderTemplateService.getDownloadNewFlowCsvUrl({ ...this.queryUtility.plainFilter, facilityOrderId: this.facilityOrder.id }))}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl
            }&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadUrl, "_blank")
    }

    @action.bound
    async openFacilityOrderNewFlowUSIntakeFindAndReplaceModal() {
        let errorMessage = null;
        if (this.facilityOrder.pickTicketHeaderId) {
            const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
            const pickTicketHeader = (await pickTicketHeaderService.get(this.facilityOrder.pickTicketHeaderId, { embed: "pickTicketHeaderStatus", fields: "pickTicketHeaderStatus" })).data;
            if (pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.abrv != "new") {
                errorMessage = pickTicketHeader.pickTicketHeaderStatus.abrv == "in-progress" ? "This action is not allowed because purchasing is in progress." : "This action is not allowed because purchasing is complete.";
            }
        }
        if (errorMessage) {
            this.rootStore.notificationStore.error(errorMessage);
            return;
        }
        this.facilityOrderNewFlowUSIntakeFindAndReplaceModal.open({
            facilityOrderId: this.facilityOrder.id,
            fetchData: async () => { this.queryUtility.fetch(); }
        });
    }

    @action.bound
    async reviewAllDischargeTemplates() {
        try {
            this.disabled = true;
            const templates = this.facilityOrderTemplatesGroupByPatient.reduce((result, item) => {
                if (item && item.facilityOrderTemplates) {
                    result = result.concat(item.facilityOrderTemplates.filter(obj => obj !== undefined && !obj.isReviewed));
                }
                return result;
            }, []);

            if (templates && templates.length > 0) {

                templates.forEach(template => {
                    template.isReviewed = true;
                });

                await this.facilityOrderTemplateService.batchUpdate(templates);
                this.checkIsReviewed();
                this.queryUtility.fetch();
            }

        } catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
        this.disabled = false;
    }

    @action.bound
    async fetchFacilityOrderTemplatesByPatient(patientId, showDischarges, reloadPatient) {
        if (reloadPatient && patientId) {
            await this.reloadFacilityOrderPatient(patientId);
        }

        let groupIndex = this.facilityOrderTemplatesGroupByPatient.findIndex(x => x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
        if (groupIndex == -1)
            return;

        let params = {
            newFlowUSIntakeStatusIds: this.queryUtility.filter.newFlowUSIntakeStatusIds,
            facilityOrderId: this.id,
            itemCategoryId: this.facilityOrder.isEnteralWeek ? this.enteralItemCategoryId : undefined,
            patientId: patientId
        };

        const itemCategoryIds = this.facilityOrder.isEnteralWeek ? [] : _.map(this.itemCategories, (i => { return i.id }));
        const showInsuranceQuestionPatients = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "0");
        const showMissingProductTemplates = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "1");

        let patientFacilityOrderTemplates = (await this.facilityOrderTemplateNewFlowService.find(params)).data.item.filter(t =>
            (itemCategoryIds.length == 0 || itemCategoryIds.includes(t.itemCategoryId)) &&
            (!showInsuranceQuestionPatients || this.hasPatientInsuranceQuestion(t.patientId)) &&
            (!showMissingProductTemplates || t.missingProduct)
        )
            .map(template => {
                return {
                    ...template,
                    itemsVisible: template.inactiveReasonId === 58 ? true : false
                };
            });

        let facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == patientId);
        if (facilityOrderPatient && patientFacilityOrderTemplates && patientFacilityOrderTemplates.length > 0) {
            groupIndex = this.facilityOrderTemplatesGroupByPatient.findIndex(x => x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
            if (groupIndex == -1)
                return;

            _.merge(this.facilityOrderTemplatesGroupByPatient[groupIndex], { id: this.facilityOrderTemplatesGroupByPatient[groupIndex].id, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: patientFacilityOrderTemplates });
            this.facilityOrderTemplatesGroupByPatient.splice(groupIndex, 1, { id: `${this.selectedStatusAbrv}-${patientId}-${uuid()}`, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: patientFacilityOrderTemplates });
        }
        else {
            groupIndex = this.facilityOrderTemplatesGroupByPatient.findIndex(x => x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
            if (groupIndex == -1)
                return;

            this.facilityOrderTemplatesGroupByPatient.splice(groupIndex, 1);
        }

        await this.fullReviewCheck(showDischarges);
    }

    @action.bound
    async fullReviewCheck(showDischarges) {
        if (this.selectedStatusAbrv == "discharge" || this.checkIsEmpty()) {
            await this.checkIsReviewed();
            this.checkIsUSIntakeCompleted(showDischarges);
        }
    }

    @action.bound
    removeFacilityOrderTemplatesByPatient(patientId, templateId) {
        const groupIndex = this.facilityOrderTemplatesGroupByPatient.findIndex(x => x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
        if (groupIndex == -1)
            return;

        let facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == patientId);
        let patientFacilityOrderTemplates = this.facilityOrderTemplatesGroupByPatient[groupIndex].facilityOrderTemplates.filter(i => templateId && i.id != templateId);

        if (facilityOrderPatient && patientFacilityOrderTemplates.length > 0) {
            this.facilityOrderTemplatesGroupByPatient.splice(groupIndex, 1, { id: `${this.selectedStatusAbrv}-${patientId}-${uuid()}`, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: patientFacilityOrderTemplates });
        }
        else {
            this.facilityOrderTemplatesGroupByPatient.splice(groupIndex, 1);
        }
    }

    @action.bound
    async checkIsUSIntakeCompleted(showDischarges) {
        if (showDischarges && this.isEmpty && this.selectedStatusAbrv == "in-progress" && !this.isReviewed) {
            this.setStatus('discharge');
            this.isInventoryRequestSent = this.facilityOrder.isInventoryRequestSent;
            this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedInventoryEmailConditions(this.id)).data;
        }
    }

    @action.bound
    async signalRAction(message) {
        if (message.table == "FO") {
            if (message.column == "SendOrder") {
                this.facilityOrder.sendOrder = true;
                this.disabledSendOrder = !this.isAdmin;
            }
            else {
                this.disabled = true;
                this.loadingTemplates = true;
                this.queryUtility.fetch();
                this.disabled = false;
            }
        }
        else if (message.table == "FOT" || message.table == "FOTI" || message.table == "FOP") {
            if (message.id == this.id && !message.patientId) {
                if (message.table === "FOTI"){
                    await this.reloadFacilityOrderTemplates(message.id);
                } else {
                    this.disabled = true;
                    this.loadingTemplates = true;
                    this.queryUtility.fetch();
                    this.disabled = false;
                }
            }
            else if (message.patientId) {
                await this.reloadFacilityOrderPatientAndTemplates(message.patientId);
            }
            else {
                if (message.table == "FOP") {
                    await this.reloadFacilityOrderPatient(message.id);
                }
                else {
                    await this.reloadFacilityOrderTemplate(message.id);
                }
            }
        }
        else if (message.table == "P") {
            this.fetchFacilityOrderTemplatesByPatient(message.patientId);
        }
        else if (message.table == "PTH") {
            this.initializePickTicketHeader();
        }
        else if (message.table == "FOS") {
            await this.getFacilityOrderStatus();
            if (this.selectedStatusAbrv == "discharge" || this.checkIsEmpty()) {
                await this.checkIsReviewed();
            }
        }
        else if (message.table == "SE") {
            if (message.column == "EmailType" && message.id == this.facilityOrder.id)
            {
                if (message.text == "InventoryRequest")
                {
                    this.isInventoryRequestSent = true;
                    this.getFacilityOrderStatus();
                    this.checkIsReviewed();
                }         
            }
        }
    }

    @action.bound
    async reloadFacilityOrderPatientAndTemplates(patientId) {
        if (!(await this.reloadFacilityOrderPatient(patientId)))
            return;

        this.fetchFacilityOrderTemplatesByPatient(patientId);
        if (this.selectedStatusAbrv == "discharge" || this.checkIsEmpty()) {
            await this.checkIsReviewed();
        }
    }

    @action.bound
    async reloadFacilityOrderPatient(patientId) {
        let response = (await this.facilityOrderPatientService.find({ rpp: 1, facilityOrderId: this.facilityOrder.id, patientId: patientId, embed: "EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus,Patient" })).data.item;
        if (!response || response.length == 0) {
            this.queryUtility.fetch();
            return false;
        }
        else {
            var patient = this.facilityOrderPatients.find(x => x.patientId == patientId);
            if (patient) {
                Object.keys(patient).forEach(key => {
                    patient[key] = response[0][key];
                });
            }
            else {
                this.facilityOrderPatients.push(response[0]);
            }
        }
        return true;
    }

    @action.bound
    async reloadFacilityOrderTemplate(facilityOrderTemplateId) {
        if (this.facilityOrderTemplatesGroupByPatient && this.facilityOrderTemplatesGroupByPatient.some(x => x.facilityOrderTemplates && x.facilityOrderTemplates.some(i => i.id === facilityOrderTemplateId))) {
            var patientId = this.facilityOrderTemplatesGroupByPatient.find(x => x.facilityOrderTemplates.some(i => i.id === facilityOrderTemplateId)).facilityOrderPatient.id;
            this.fetchFacilityOrderTemplatesByPatient(patientId);
        }
    }

    @action.bound
    async reloadFacilityOrderTemplates(id) {
        let params = {
            facilityOrderId: id,
            itemCategoryId: this.facilityOrder.isEnteralWeek ? this.enteralItemCategoryId : undefined
        }

        const itemCategoryIds = this.facilityOrder.isEnteralWeek ? [] : _.map(this.itemCategories, (i => { return i.id }));
        const showInsuranceQuestionPatients = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "0");
        const showMissingProductTemplates = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "1");

        let filterTemplates = (await this.facilityOrderTemplateNewFlowService.find(params)).data.item.filter(t =>
            (itemCategoryIds.length == 0 || itemCategoryIds.includes(t.itemCategoryId)) &&
            (!showInsuranceQuestionPatients || this.hasPatientInsuranceQuestion(t.patientId)) &&
            (!showMissingProductTemplates || t.missingProduct)
        )
            .map(template => {
                return {
                    ...template,
                    itemsVisible: template.inactiveReasonId === 58 ? true : false
                };
            });

        let groupByPatient = _.groupBy(filterTemplates, 'patientId');
        _.each(groupByPatient, async (val, key,) => {
            await this.reloadFacilityOrderPatientAndTemplates(key);
        });
    }
}

export default FacilityOrderNewFlowUSIntakePreviewViewStore;